













































import { Component, Vue } from 'vue-property-decorator';
import Cognito from "@/authorization/cognito";

@Component
export default class EmailConfirm extends Vue {
    email: string | null = null;

    cognito = new Cognito();

    mounted() {
        this.email = localStorage.email;
        localStorage.email = null;

        if (this.email == 'null') {
            this.$router.push('sign-in');
        }
    }

    reSend() {
      const email = this.email;
      if (email === null) {
        return;
      }
      this.cognito.resendConfirmUrl(email);
      //this.cognito.resendConfirmUrl();
    }
    /*
    clientId = '';
    userName = '';
    confirmationCode = '';
    msg = 'Eメールを検証しています....';

    reqConfirm(){
        const cognito = new Cognito();
        console.log(cognito.getConfirmUrl(this.userName, this.clientId, this.confirmationCode));
        this.axios.get(cognito.getConfirmUrl(this.userName, this.clientId, this.confirmationCode))
            .then(response => {
                console.log(response);
                this.msg = '検証成功';
            })
            .catch(error => {
                console.log(error.response);
                this.msg = '検証に失敗しました'
            });
    }

    mounted(){
        this.clientId = String(this.$route.query.client_id);
        this.userName = String(this.$route.query.user_name);
        this.confirmationCode = String(this.$route.query.confirmation_code);

        console.log(this.clientId);

        if(!this.clientId || !this.userName || !this.confirmationCode) {
            this.msg = '検証に失敗しました';
            return;
        }
        this.reqConfirm();
    }

     */
}
